import { fromJS } from 'immutable'

import { SSO_GET, SSO_UPDATE, SSO_ERROR, SSO_LINK_POST } from 'actions/sso'

// Reducer
// ---------------------------------------------------------------------------

export const initialState = fromJS({
  error: false,
  errorData: null,
  loading: false,
  returnData: null,
})

export default function createSSOReducer(state = initialState, action) {
  switch (action.type) {
    case SSO_GET:
    case SSO_LINK_POST:
      return _getSSO(state)
    case SSO_UPDATE:
      return _updateSSO(state, action.payload)
    case SSO_ERROR:
      return _errorSSO(state, action.payload)
    default:
      return state
  }
}

const _getSSO = state => {
  return state.update('loading', () => true)
}

const _updateSSO = (state, payload) => {
  return state
    .set('returnData', fromJS(payload.data))
    .update('loading', () => false)
    .update('error', () => false)
    .update('errorData', () => null)
}

const _errorSSO = (state, payload) => {
  return state
    .set('error', payload.error)
    .set('errorData', fromJS(payload.data))
    .update('loading', () => false)
}
